export class HistoryPropertyCodes {
    static readonly DATE = 'date';
    static readonly USER_NAME = 'userName';
    static readonly TYPE = 'type';
    static readonly TEXT = 'text';
    static readonly SEVERITY = 'severityLevel';
}
